import type { MatchData } from '../types'
import { teamSummaries } from '../data/match'

export function MatchHeader({ match, ourTeam }: { match: MatchData; ourTeam: string }) {
  const [winner, loser] = teamSummaries(match)
  const weWon = winner.name === ourTeam
  return (
    <section
      className="border border-border bg-surface p-6"
      style={{ borderRadius: 'var(--radius)', boxShadow: 'var(--shadow)' }}
    >
      <div className="mb-5 flex items-center justify-between">
        <span className="font-display text-xs uppercase tracking-[0.2em] text-text-faint">
          {match.map} · {match.rounds} rounds
        </span>
        <span
          className="border border-border px-2 py-0.5 text-[10px] uppercase tracking-wider text-text-dim"
          style={{ borderRadius: 'var(--radius)' }}
        >
          FACEIT
        </span>
      </div>

      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-4">
        <TeamCell name={winner.name} isOurs={winner.name === ourTeam} align="right" />
        <div className="font-display text-5xl font-bold tabular-nums">
          <span className={weWon ? 'text-accent' : 'text-text'}>{winner.score}</span>
          <span className="mx-3 text-text-faint">–</span>
          <span className="text-text-dim">{loser.score}</span>
        </div>
        <TeamCell name={loser.name} isOurs={loser.name === ourTeam} align="left" />
      </div>

      <div className="mt-4 text-center">
        <span
          className="inline-block px-3 py-1 text-xs font-medium"
          style={{
            borderRadius: 'var(--radius)',
            color: weWon ? 'var(--accent-ink)' : 'var(--loss)',
            background: weWon ? 'var(--accent)' : 'transparent',
            border: weWon ? 'none' : '1px solid var(--loss)',
          }}
        >
          {weWon ? 'WIN' : 'LOSS'} · {ourTeam}
        </span>
      </div>
    </section>
  )
}

function TeamCell({ name, isOurs, align }: { name: string; isOurs: boolean; align: 'left' | 'right' }) {
  return (
    <div className={align === 'right' ? 'text-right' : 'text-left'}>
      <div className={`font-display text-xl font-semibold ${isOurs ? 'text-accent' : 'text-text'}`}>
        {name}
      </div>
    </div>
  )
}
